import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const DailyCallReportFunction = async(param:any )=>{
   const response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_DAILY_CALL_REPORT}`,{params:param});
   const rowData = await response?.data;
  const formatedData = Array.isArray(rowData?.data?.DailyCallReportData)
  ? rowData.data.DailyCallReportData.map((item: any) => ({
      EmployeeCode: item.EmployeeCode,
      EmployeeName: item.EmployeeName,
      DcrDate: item.DcrDate,
      DcrTime: item.DcrTime,
      AgendaName:item.AgendName,
      OutletName: item.OutletName,
      DoctorName: item.DoctorName,
      Classification: item.Classification,
      OutletType: item.OutletTypeName,
      JwEmployeeCode: item.JwEmployeeCode,
      JwEmployee: item.JwEmployee,
      TerritoryName: item.TerritoryName,
      TownName:item.StownName,
      CreatedDate: item.CreatedAt,
      DcrLatLong: item.DcrLatLong,
      DoctorsFeedback: item.DoctorsFeedbackForOurServices,
      Remarks: item.Remarks,
      WhatIsTheBusinessPotentialOfTheDoctor: item.WhatIsTheBusinessPotentialOfTheDoctor,
      // "CreatedDate": "2024-01-08"
    }))
  : [];

 return { formatedData, rowData };
}
   